// @flow
import { createReducer } from 'reduxsauce';
import I18n from '../i18n/I18n';
import Types from '../actions/Types';

// Init State
export const INITIAL_STATE = {
    dashboard: null,
    errorMessage: null,
    successMessage: null,
    isLoading: false,
};

/* Generic error message */
const genericError = 'Something went wrong';

/* Get dashboard */
export const getDashboard = (state: Object = INITIAL_STATE) => {
  return ({
    ...state,
    isLoading: true })};

export const getDashboardSuccess = (state: Object = INITIAL_STATE, action: Object) => {
  return {
    ...state,
    dashboard: action.dashboard,
    isLoading: false,
}};

export const getDashboardFailure = (state: Object = INITIAL_STATE, action: Object) => ({
    ...state,
    isLoading: false,
    errorMessage: action.errorMessage || genericError,
});


const ACTION_HANDLERS = {
    [Types.GET_DASHBOARD]: getDashboard,
    [Types.GET_DASHBOARD_SUCCESS]: getDashboardSuccess,
    [Types.GET_DASHBOARD_FAILURE]: getDashboardFailure,
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/reducers/DashboardReducer.js